import { ComponentFactoryResolver, Directive, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { NzPopconfirmComponent, NzTooltipDirective } from 'ng-zorro-antd';

@Directive({
    selector: '[atx-pop-confirm]'
})

export class AtxPopConfirmDirective  extends NzTooltipDirective {
    constructor(
        elementRef: ElementRef,
        hostView: ViewContainerRef,
        resolver: ComponentFactoryResolver,
        renderer: Renderer2,
        tooltip: NzPopconfirmComponent,
    ) {
        super(elementRef, hostView, resolver, renderer, tooltip);
    }
}
